import { FC } from 'react';

import { giftApiSmallButton } from './giftApiStyles';

export const GiftApiPagination: FC<{
  total: number;
  page: number;
  pageSize: number;
  onChange: (page: number) => void;
}> = ({ total, page, pageSize, onChange }) => {
  if (total <= pageSize) return null;
  const pages = Math.ceil(total / pageSize);
  const buttonClass = giftApiSmallButton;
  return (
    <nav
      aria-label="목록 페이지"
      className="mt-3 flex flex-wrap items-center justify-between gap-2 text-xs text-gray-600"
    >
      <span aria-live="polite">
        전체 {total.toLocaleString()}건 중 {(page - 1) * pageSize + 1}–
        {Math.min(page * pageSize, total)}건
      </span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          className={buttonClass}
          disabled={page === 1}
          onClick={() => onChange(page - 1)}
        >
          이전
        </button>
        <span>
          {page} / {pages} 페이지
        </span>
        <button
          type="button"
          className={buttonClass}
          disabled={page === pages}
          onClick={() => onChange(page + 1)}
        >
          다음
        </button>
      </div>
    </nav>
  );
};
